import React from "react";
import { motion } from "framer-motion";
import { Zap } from "lucide-react";

const specs = [
  {
    category: "Sensors",
    items: [
      { name: "Heart Rate Monitor", value: "PPG-based, ±2 BPM accuracy" },
      { name: "SpO2 Sensor", value: "Pulse oximetry, ±2% accuracy" },
      { name: "Temperature Sensor", value: "±0.1°C accuracy, 0.1s response" },
      { name: "ECG Monitor", value: "12-lead compatible, 500Hz sampling" }
    ]
  },
  {
    category: "Connectivity",
    items: [
      { name: "Wireless Protocol", value: "WiFi 6, Bluetooth 5.2, LoRaWAN" },
      { name: "Cloud Platform", value: "AWS IoT Core, Firebase Integration" },
      { name: "Data Encryption", value: "AES-256, TLS 1.3" },
      { name: "API Support", value: "RESTful APIs, WebSocket real-time" }
    ]
  },
  {
    category: "Performance",
    items: [
      { name: "Battery Life", value: "Up to 7 days continuous monitoring" },
      { name: "Data Latency", value: "< 100ms end-to-end" },
      { name: "Uptime", value: "99.9% availability SLA" },
      { name: "Scalability", value: "Support for 10,000+ concurrent devices" }
    ]
  }
];

const TechnicalSpecsSection = () => {
  return (
    <section id="specs" className="specs-section">
      <div className="container">
        <motion.div className="md-section-header"
          initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
        >
          <h2>Technical Specifications</h2>
          <p>Enterprise-grade hardware and software specifications for reliable healthcare monitoring</p>
        </motion.div>

        <div className="specs-grid">
          {specs.map((s, idx) => (
            <motion.div key={s.category} className="spec-card"
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ delay: idx * 0.12 }}
            >
              <div className="spec-header"><Zap className="spec-icon" /> <h3>{s.category}</h3></div>
              <div className="spec-body">
                {s.items.map((it, i) => (
                  <div className="spec-row" key={i}>
                    <span className="spec-name">{it.name}</span>
                    <span className="spec-value">{it.value}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TechnicalSpecsSection;
